import { getConnections } from '@wagmi/core';
import { wagmiAdapterConfig } from '../Config/WagmiConfig';
import { ProviderInterface } from '@coinbase/wallet-sdk/dist/core/provider/interface';
import { useAccount } from 'wagmi';
import {
  REACT_APP_BLOCK_EXPLORER_OPEN_ZK_URL,
  REACT_APP_ETH_CHAIN_ID_HEX,
  REACT_APP_OPENZK_CHAIN_ID_HEX,
  REACT_APP_OPENZK_RPC,
} from '../Config/Config';
import { useState } from 'react';

export function useWalletChain() {
  const { isConnected, address } = useAccount();
  const [error, setError] = useState<string | null>(null);

  const addOZKChain = async () => {
    setError(null);
    const connections = getConnections(wagmiAdapterConfig);

    if (!isConnected || !address || !connections) {
      return;
    }

    const walletProvider =
      (await connections[0].connector.getProvider()) as ProviderInterface;

    try {
      await walletProvider.request({
        method: 'wallet_addEthereumChain',
        params: [
          {
            chainId: REACT_APP_OPENZK_CHAIN_ID_HEX,
            chainName: 'OpenZK',
            nativeCurrency: {
              name: 'OpenZK',
              symbol: 'ozETH',
              decimals: 18,
            },
            rpcUrls: [REACT_APP_OPENZK_RPC],
            blockExplorerUrls: [REACT_APP_BLOCK_EXPLORER_OPEN_ZK_URL],
          },
        ],
      });
    } catch (error) {
      try {
        await walletProvider.request({
          method: 'wallet_switchEthereumChain',
          params: [
            {
              chainId: REACT_APP_OPENZK_CHAIN_ID_HEX,
            },
          ],
        });
      } catch (error) {
        console.log('❌ Error adding chain:', error);
        setError(
          'Error adding chain: you need to add manually the OpenZK chain',
        );
      }
    }
  };

  const addEthereumChain = async () => {
    setError(null);
    const connections = getConnections(wagmiAdapterConfig);

    if (!isConnected || !address || !connections) {
      return;
    }

    const walletProvider =
      (await connections[0].connector.getProvider()) as ProviderInterface;

    try {
      await walletProvider.request({
        method: 'wallet_switchEthereumChain',
        params: [
          {
            chainId: REACT_APP_ETH_CHAIN_ID_HEX,
          },
        ],
      });
    } catch (error) {
      console.log('❌ Error adding chain:', error);
      setError(
        'Error adding chain: you need to add manually the Ethereum chain',
      );
    }
  };

  return { addOZKChain, addEthereumChain, error };
}
